import { useState } from "react";
import { Menu, X, Search } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useTheme } from "../../context/ThemeContext";
import { getThemeClasses } from "../utils/themeClass";

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const { theme, toggleTheme } = useTheme();

  const themeClass = getThemeClasses(theme);

  const linkStyle = `transition cursor-pointer ${themeClass.baseText} ${themeClass.hoverText}`;

  const toggleMenu = () => {
    setIsOpen(!isOpen);
    document.body.style.overflow = isOpen ? "auto" : "hidden";
  };

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 h-16 px-4 md:px-8 shadow-md border-b ${themeClass.bgColor} ${themeClass.borderColor}`}
    >
      <div className="w-full max-w-7xl mx-auto flex justify-between items-center h-full">
        {/* Logo */}
        <div className="flex items-center space-x-4">
          <a
            onClick={() => navigate("/")}
            className={`text-xl md:text-2xl font-bold cursor-pointer ${linkStyle}`}
          >
            Browserarena
          </a>
        </div>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center space-x-6">
          <button
            onClick={() => navigate("/search")}
            className={linkStyle}
            aria-label="Search"
          >
            <Search size={22} />
          </button>
          <button onClick={() => navigate("/")} className={linkStyle}>
            Home
          </button>
          <button onClick={() => navigate("/categories")} className={linkStyle}>
            Categories
          </button>
          <button onClick={() => navigate("/about")} className={linkStyle}>
            About
          </button>
          <button
            onClick={toggleTheme}
            className={`p-2 rounded-lg border text-sm transition hover:scale-105 ${themeClass.toggleButton}`}
          >
            {theme === "dark" ? "☀️ Light" : "🌙 Dark"}
          </button>
        </div>

        {/* Mobile Nav Button */}
        <div className="flex md:hidden items-center">
          <button onClick={toggleMenu} className={themeClass.baseText}>
            {isOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isOpen && (
        <div
          className={`absolute top-16 left-0 w-full shadow-md border-t ${themeClass.bgColor} ${themeClass.borderColor}`}
        >
          <ul className={`flex flex-col p-4 space-y-4 ${themeClass.baseText}`}>
            {[
              { name: "Search", path: "/search", icon: "🔎" },
              { name: "Home", path: "/", icon: "🏠" },
              { name: "Categories", path: "/categories", icon: "🗂️" },
              { name: "About", path: "/about", icon: "ℹ️" },
            ].map(({ name, path, icon }) => (
              <li key={name}>
                <button
                  onClick={() => {
                    navigate(path);
                    toggleMenu();
                  }}
                  className={`${linkStyle} flex items-center w-full text-left space-x-2`}
                >
                  <span>{icon}</span>
                  <span>{name}</span>
                </button>
              </li>
            ))}
          </ul>
        </div>
      )}
    </nav>
  );
}
